import React, { useState, useEffect, createContext } from "react";
import { RatingsService, SpinTheWheelService } from "../services";
import { useLoyalty } from "../hooks";

// api services
// import { SpinTheWheelService } from "../services";
const getToken = () => JSON.parse(localStorage.getItem("token"));

const RatingsContext = createContext({});

const Provider = ({ children }) => {
  const [ratingValues, setRatingValues] = useState({
    feature: "",
    rating: "",
    nps: "",
    unhappyFeedback: "",
    recommendations: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionResponseData, setSubmissionResponseData] = useState();
  const [submissionError, setSubmissionError] = useState();
  const [featureRef, setFeatureRef] = useState();
  const { getInteractions } = useLoyalty();

  function updateRatingValues(key, value) {
    setRatingValues({ ...ratingValues, [key]: value });
  }

  async function submitRatings() {
    try {
      setIsSubmitting(true);
      setSubmissionError(null);
      setSubmissionResponseData(null);
      const token = getToken();
      const data = await RatingsService.submitRatings({
        ...ratingValues,
        ref: featureRef,
        token,
      });
      await getInteractions();
      if (data) {
        setSubmissionResponseData(data);

      }
    } catch (e) {
      console.log(e);
      setSubmissionError(e);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <RatingsContext.Provider
      value={{
        ratingValues,
        isSubmitting,
        submissionResponseData,
        submissionError,
        setSubmissionResponseData,
        submitRatings,
        updateRatingValues,
        setFeatureRef,
      }}
    >
      {children}
    </RatingsContext.Provider>
  );
};

RatingsContext.ProviderWrapper = Provider;

export default RatingsContext;
